import ChannelInviteModal from './ChannelInvite'
export default ChannelInviteModal
